import { Instance } from 'mobx-state-tree';
import { CustomerOrdersResultDtoModelBase } from './CustomerOrdersResultDtoModel.base';

/* The TypeScript type of an instance of CustomerOrdersResultDtoModel */
export interface CustomerOrdersResultDtoModelType extends Instance<typeof CustomerOrdersResultDtoModel.Type> {}

/* A graphql query fragment builders for CustomerOrdersResultDtoModel */
export { selectFromCustomerOrdersResultDto, customerOrdersResultDtoModelPrimitives, CustomerOrdersResultDtoModelSelector } from './CustomerOrdersResultDtoModel.base';

/**
 * CustomerOrdersResultDtoModel
 */
export const CustomerOrdersResultDtoModel = CustomerOrdersResultDtoModelBase;
